export default __webpack_public_path__ + "static/media/shape-dots2.62cab20c.svg";